import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import LocomotiveScroll from "locomotive-scroll";
import SubPage from "../SubPage";
import { PAGE_KEY_INSIGHTS } from "../constants";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';
gsap.registerPlugin(ScrollTrigger)

class Framework {
    constructor() {
        this.pageContainer = document.querySelector(".framework-container");
        if (!this.pageContainer) {
            console.warn("Page container not found. Exiting Framework initialization.");
            return;
        }
        this.pinWrap = document.querySelector(".framework-container .pin-wrap");
        this.pinnedSection = document.querySelector(".framework-container .pinned-section");
        this.dummySections = document.querySelectorAll(".framework-container .dummy-section");
        this.frameworkContext = document.querySelector(".framework-container .framework-context");

        this.scrollProgress = document.querySelector('#framework .scrollProgress')

        this.sectionTitles = document.querySelectorAll(".framework-container .section_title_block .section_title");
        this.sectionDescriptions = document.querySelectorAll(".framework-container .section_title_block .section_title .paragraph");

        this.imageCards = document.querySelectorAll(".framework-container .section-grid-block .section-col .img-card");
        this.otherImageCards = document.querySelectorAll(".framework-container .section-grid-block .section-col .other-card");
        this.imageTitles = document.querySelectorAll(".framework-container .section-grid-block .section-col .img-card .img-title");

        this.sectionGridBlock = document.querySelector('.framework-container .section-grid-block')
        this.sectionContainer = document.querySelector('.framework-container .section-grid-block .section-grid-container')

        this.sectionCols = document.querySelectorAll('.framework-container .section-grid-block .section-col')
        this.colSmall = document.querySelectorAll('.framework-container .section-grid-block .col-small')
        this.colHighlighted = document.querySelectorAll('.framework-container .section-grid-block .col-highlight')
        this.imageBlocks = document.querySelectorAll('.framework-container .section-grid-block .img-block')

        this.colSmallImgBlocks = document.querySelectorAll('.framework-container .section-grid-block .col-small .img-block')
        this.colHighlightedImgBlocks = document.querySelectorAll('.framework-container .section-grid-block .col-highlight .img-block')

        this.firstCards = document.querySelectorAll('.framework-container .section-grid-block .first-card')

        this.colSmallColTitle = document.querySelectorAll('.framework-container .section-grid-block .col-small .col-title')
        this.colHighlightedColTitle = document.querySelectorAll('.framework-container .section-grid-block .col-highlight .col-title')

        this.colSmallCardBlocks = document.querySelectorAll('.framework-container .section-grid-block .col-small .card-block')
        this.cardBlocks = document.querySelectorAll('.framework-container .section-grid-block .card-block')

        this.colTitle = document.querySelectorAll('.framework-container .section-grid-block .section-col .col-title')
        this.colTitle2 = document.querySelectorAll('.framework-container .section-grid-block .card-block .col-title2')

        this.frameworkBtnBlock = document.querySelector('.framework-container .framework-btn-block')

        this.isPortrait = window.innerWidth <= 992
        this.isSmallerDesktop = window.innerWidth <= 1440

        this.tippyInstances = []


        // Initialize Locomotive Scroll
        this.locoScroller = new LocomotiveScroll({
            el: this.pageContainer,
            smooth: true,
            multiplier: 1,
            touchMultiplier: 2,  // Adjust for touch scroll speed
            smartphone: {
                smooth: true,
            },
            tablet: {
                smooth: true,
            },
        });

        this.locoScroller.on("scroll", (e) => {
            // Use Locomotive Scroll to track scroll progress
            const totalScrollHeight = e.limit.y;
            const currentScrollPosition = e.scroll.y;
            const scrollProgress = (currentScrollPosition / totalScrollHeight) * 100;
            this.scrollProgress.style.height = parseInt(scrollProgress) + '%'
            // console.log("Locomotive Scroll Progress:", scrollProgress);
        });

        const locoScroller = this.locoScroller;
        this.locoScroller.on("scroll", ScrollTrigger.update);  // Trigger ScrollTrigger updates on scroll event

        ScrollTrigger.scrollerProxy(this.pageContainer, {
            scrollTop(value) {
                return arguments.length ? locoScroller.scrollTo(value, 0, 0) : locoScroller.scroll.instance.scroll.y;
            },
            scrollLeft(value) { },
            getBoundingClientRect() {
                return { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
            },
            pinType: this.pageContainer.style.transform ? "transform" : "fixed",
        });

        var title01 = gsap.timeline({ paused: true, onStart: () => { this.lockScroll(this.locoScroller) }, onComplete: () => { this.unlockScroll(this.locoScroller) } })
        var title02 = gsap.timeline({ paused: true })
        var title03 = gsap.timeline({ paused: true })
        var titleDescription = gsap.timeline({ paused: true })

        // Set up ScrollTrigger for pinning
        gsap.to(this.pinnedSection, {
            scrollTrigger: {
                scroller: this.pageContainer,  // Attach ScrollTrigger to the page container
                scrub: true,
                // snap: true,
                trigger: this.pinnedSection,
                pin: ".framework-container .pin-item",  // Pin the element
                pinSpacing: false,  // No additional space after pinning
                start: "top top",  // Start when the top of the section hits 80% of the viewport
                end: () => "+=" + document.querySelector('.framework-container #pinned-section').offsetHeight * 3,  // End when the bottom of the section hits 30% of the viewport

            }
        });

        title01.to(this.sectionTitles[0], {
            duration: 1,
            opacity: 1,
            y: 0
        }, 1)

        title02.to(this.sectionTitles[1], {
            duration: 1,
            opacity: 1,
            y: 0
        }, 1)

        title03.to(this.sectionTitles[2], {
            duration: 1,
            opacity: 1,
            y: 0
        }, 1)

        titleDescription.to(this.sectionDescriptions, {
            duration: 1,
            opacity: 0,
        })

        // FIRST COL ANIMATION 
        var tlCol = gsap.timeline({
            paused: true,
            onComplete: () => { this.unlockScroll(this.locoScroller) },
            onReverseComplete: () => { this.unlockScroll(this.locoScroller) }
        })



        tlCol.from(this.sectionCols, {
            duration: 1,
            opacity: 0,
            y: 100
        }).to(this.imageBlocks, {
            duration: 1,
            height: "35vh",
            // scale: 1
        }, '-=1')
            .to(this.colSmall, {
                duration: 1,
                opacity: 1
            }, '-=1')
            .to(this.colSmall[1], {
                duration: 1,
                paddingTop: "5vh"
            }, '-=1')


        // SECOND COL ANIMATION
        var tlCol2 = gsap.timeline({
            paused: true,
            onComplete: () => { this.unlockScroll(this.locoScroller) },
            onReverseComplete: () => {
                this.unlockScroll(this.locoScroller),
                    title01.restart()
            },
        })

        tlCol2.to(this.colHighlighted, {
            duration: 1,
            width: "28.5%",
            transformOrigin: "center",
            clipPath: "none",
        }).to(this.sectionCols, {
            duration: 1,
            margin: 0
        }, '-=1')
            .fromTo(this.colSmall, {
                opacity: 1
            }, {
                duration: 1,
                paddingTop: "5vh",
                opacity: 0.3,
            }, '-=1')
            .to(this.colSmallImgBlocks, {
                duration: 1,
                transformOrigin: "center",
                height: "35vh",
                borderWidth: 0
            }, '-=1')
            .to(this.colHighlightedImgBlocks, {
                duration: 1,
                transformOrigin: "center",
                scale: 1,
            }, '-=1')
            .to(this.colHighlightedImgBlocks, {
                duration: 1,
                transformOrigin: "center",
                height: "45vh"
            }, '-=0.7')
            .to(this.sectionContainer, {
                duration: 1,
                gap: "40px"
            }, '-=1')


        // THIRD COL ANIMATION
        var tlCol3 = gsap.timeline({
            paused: true,
            onComplete: () => { this.unlockScroll(this.locoScroller) },
            onReverseComplete: () => {
                this.unlockScroll(this.locoScroller)
                this.isPortrait ? this.sectionCols.forEach(c => c.classList.add('normal')) : null
            }
        })

        tlCol3.to(this.imageCards, {
            duration: 1,
            y: 0,
            opacity: 1,
            visibility: "visible"
        })
            .to(this.colHighlighted, {
                width: "16.66%",
            }, '-=1')
            .to(this.imageBlocks, {
                duration: 1,
                height: "12vh",
                border:"none"
            }, '-=1')
            .fromTo(this.colSmall, {
                opacity: 0.3
            }, {
                duration: 1,
                paddingTop: "0vh",
                opacity: 1
            }, '-=1')
            .fromTo(this.colTitle2, {
                opacity: 1
            }, {
                opacity: 0,
                duration: 1,
                height: 0,
                display: "none"
            }, '-=1')
            .to(this.imageCards, {
                duration: 1,
                marginBottom: "15px",
            }, '-=1')
            .fromTo(this.sectionCols, {
                gridTemplateRows: "0rem 2fr",
                rowGap: "0px",
            }, {
                gridTemplateRows: this.isSmallerDesktop ? "3.3rem 2fr" : "4rem 2fr",
                rowGap: "10px",
                duration: 1,
            }, '-=1')
            .fromTo(this.colTitle, {
                opacity: 0,
                height: 0,
            }, {
                duration: 1,
                opacity: 1,
                height: "auto"
            }, '-=1')
            .to(this.imageTitles, {
                duration: 1,
                y: 0,
                opacity: 1,
            }, 0.5)


        var tlCol4 = gsap.timeline({
            paused: true,
            onComplete: () => { this.unlockScroll(this.locoScroller) },
            onReverseComplete: () => { this.unlockScroll(this.locoScroller) }
        })

        tlCol4.to(this.sectionGridBlock, {
            y: window.innerHeight <= 863 ? -70 : -100,
            duration: 1
        }).to(this.frameworkBtnBlock, {
            duration: 1,
            y: window.innerHeight <= 863 ? -100 : -70,
            opacity: 1,
            visibility: "visible",
        }, '-=1')

        // //GSAP SCROLL TRIGGER

        gsap.to(this.pinnedSection, {
            scrollTrigger: {
                scroller: this.pageContainer,  // Attach ScrollTrigger to the page container
                scrub: true,
                // snap: true,
                trigger: this.pinnedSection,
                start: "top center",
                end: "bottom center",
                onEnter: () => {
                    title01.timeScale(2).restart()
                    tlCol.restart()
                },
                onLeave: () => {

                },
                onEnterBack: () => {
                    title01.restart(true)
                    title02.reverse()
                    tlCol2.reverse()
                    this.lockScroll(this.locoScroller);
                },

            }
        })

        gsap.to(this.dummySections[0], {
            scrollTrigger: {
                scroller: this.pageContainer,  // Attach ScrollTrigger to the page container
                scrub: true,
                // snap: true,
                trigger: this.dummySections[0],
                snap: false,
                start: "top center",
                end: "bottom center",
                onEnter: () => {
                    this.lockScroll(this.locoScroller);
                    title02.restart()
                    title01.reverse()
                    tlCol2.restart()
                },
                onLeave: () => {

                },
                onEnterBack: () => {
                    this.lockScroll(this.locoScroller);
                    title02.restart()
                    title03.reverse()
                    tlCol3.reverse()
                    this.destroyTippy()
                }
            }
        })


        gsap.to(this.dummySections[1], {
            scrollTrigger: {
                scroller: this.pageContainer,  // Attach ScrollTrigger to the page container
                scrub: true,
                // snap: true,
                trigger: this.dummySections[1],
                snap: false,
                start: "top center",
                end: "bottom center",
                onEnter: () => {
                    this.lockScroll(this.locoScroller);
                    title03.restart()
                    title02.reverse()
                    tlCol3.restart()
                    this.initTippy();
                },
                onLeave: () => {

                },
                onEnterBack: () => {
                    this.lockScroll(this.locoScroller);
                    titleDescription.reverse()
                    tlCol4.reverse();
                    this.initTippy();
                }

            }
        })

        gsap.to(this.dummySections[2], {
            scrollTrigger: {
                scroller: this.pageContainer,  // Attach ScrollTrigger to the page container
                scrub: true,
                trigger: this.dummySections[2],
                snap: false,
                start: "top center",
                end: "bottom center",
                onEnter: () => {
                    this.lockScroll(this.locoScroller);
                    titleDescription.restart()
                    tlCol4.restart()
                },
                onLeave: () => {
                },

            }
        })

        // Refresh ScrollTrigger after any changes
        ScrollTrigger.addEventListener("refresh", () => this.locoScroller.update());
        ScrollTrigger.refresh();


        this.init()
    }

    initTippy() {
        // Initialize Tippy.js for your elements
        this.imageCards.forEach(card => {
            const template = document.querySelector(`#${card.dataset.target}`)
            const instance = tippy(card, {
                content: template.innerHTML,
                allowHTML: true,
                placement: 'right',
                trigger: 'click',
                theme: 'img_card_tooltip',
                offset: [-10, 10],
                appendTo: document.querySelector('#framework .section-grid-container'),
                popperOptions: {
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: document.querySelector('#framework .section-grid-container'), // Set container as boundary
                            },
                        },
                    ],
                },
            });

            this.tippyInstances.push(instance)
        });
    }

    destroyTippy() {
        // Destroy all Tippy instances
        this.tippyInstances.forEach(instance => instance.destroy());
    }

    init() {
        this.countryScoreBtn = document.querySelector('.framework-container .framework-btn-block #countryScoreBtn')
        this.keyInsightsBtn = document.querySelector('.framework-container .framework-btn-block #keyInsightsBtn')

        // this.countryScoreBtn.addEventListener('click', () => {
        //     SubPage.getInstance().hideFramworkPage()
        //     document.querySelector('[data-page="countryScoreCard"]').click();
        // });

        this.keyInsightsBtn.addEventListener('click', () => {
            SubPage.getInstance().showKeyInsightsPage()
            SubPage.setCurrentPage(PAGE_KEY_INSIGHTS)
        })
    }


    // Locking the scroll
    lockScroll(scroller) {
        scroller.stop(); // This stops Locomotive Scroll's scroll event
    }

    unlockScroll(scroller) {
        scroller.start(); // This resumes Locomotive Scroll's scroll event
    }

    resetFramework() {

        // Reset Locomotive Scroll
        this.locoScroller.scrollTo(0, {
            duration: 0,  // Instantly move to top
            disableLerp: true  // No easing
        });

        // // Reinitialize ScrollTrigger
        // ScrollTrigger.refresh();

        // // Restart animations (optional)
        // this.init();
    }


}



export default Framework;